import img1 from '~/assets/donations/1.png'
import img2 from '~/assets/donations/2.png'
import img3 from '~/assets/donations/3.png'
import img4 from '~/assets/donations/4.png'

export const configs = [
  {
    productId: 75,
    img: img1,
    price: 50,
    numbers: {
      0: 125,
      1: 20,
      2: 5,
      3: 4000,
    },
  },
  {
    productId: 76,
    img: img2,
    price: 100,
    numbers: {
      0: 250,
      1: 40,
      2: 10,
      3: 8000,
    },
  },
  {
    productId: 77,
    img: img3,
    price: 250,
    numbers: {
      0: 625,
      1: 100,
      2: 25,
      3: 20000,
    },
  },
  {
    productId: 78,
    img: img4,
    price: 800,
    numbers: {
      0: 2000,
      1: 320,
      2: 80,
      3: 64000,
    },
  },
]
